import { useEffect } from "react";
import { getTagConfig } from "../lib/analytics";

const upsert = (selector, attrs) => {
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    Object.entries(attrs.meta).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  el.setAttribute("content", attrs.content);
};

export const SEO = ({ title, description, jsonLd, robots, canonical }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      upsert('meta[name="description"]', { meta: { name: "description" }, content: description });
      upsert('meta[property="og:description"]', { meta: { property: "og:description" }, content: description });
    }
    if (title) upsert('meta[property="og:title"]', { meta: { property: "og:title" }, content: title });
    upsert('meta[property="og:type"]', { meta: { property: "og:type" }, content: "website" });
    upsert('meta[property="og:site_name"]', { meta: { property: "og:site_name" }, content: "FLASH Service & Consulting" });
    // canonical e og:url: SEMPRE dominio canonico di produzione (mai preview/emergent.host)
    // Normalizzazione: niente trailing slash, /categoria/:slug → URL canonica top-level /:slug
    getTagConfig().then((cfg) => {
      const base = (cfg.siteUrl || window.location.origin).replace(/\/$/, "");
      let path = window.location.pathname.replace(/\/+$/, "") || "/";
      if (path.startsWith("/categoria/")) path = path.slice("/categoria".length);
      const finalUrl = base + (canonical || path);
      upsert('meta[property="og:url"]', { meta: { property: "og:url" }, content: finalUrl });
      let canonicalEl = document.querySelector('link[rel="canonical"]');
      if (!canonicalEl) {
        canonicalEl = document.createElement("link");
        canonicalEl.setAttribute("rel", "canonical");
        document.head.appendChild(canonicalEl);
      }
      canonicalEl.setAttribute("href", finalUrl);
    });

    let robotsMeta = document.querySelector('meta[name="robots"]');
    // staging/anteprima/sottodominio piattaforma: mai indicizzare
    const isStaging = /preview\.|localhost|127\.0\.0\.1|emergent\.host/.test(window.location.hostname);
    const robotsValue = isStaging ? "noindex, nofollow" : robots;
    if (robotsValue) {
      if (!robotsMeta) {
        robotsMeta = document.createElement("meta");
        robotsMeta.setAttribute("name", "robots");
        document.head.appendChild(robotsMeta);
      }
      robotsMeta.setAttribute("content", robotsValue);
    } else if (robotsMeta) {
      robotsMeta.remove();
    }
    const scripts = [];
    (jsonLd || []).forEach((data) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.text = JSON.stringify(data);
      document.head.appendChild(s);
      scripts.push(s);
    });
    return () => scripts.forEach((s) => s.remove());
  }, [title, description, jsonLd, robots, canonical]);
  return null;
};
